import { Data } from '../signup-data/DATA';
import { getRecommendedHubletResponse } from '../store/http-responses/selectors';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { Step } from '../views/Step';
export const getPropertiesToTrack = state => {
  const hubletResponse = getRecommendedHubletResponse(state);
  const recommendedHublet = hubletResponse ? hubletResponse.region : null;
  const hublet = getSignupDataValue(state, Data.HubletSelection);
  const isUsingHubletRecommendation = hublet === recommendedHublet;
  return {
    [Step.HubletSelection]: {
      isUsingHubletRecommendation
    },
    [Step.CompanyDetails]: {
      isUsingHubletRecommendation
    }
  };
};